import { useAuth0 } from "@auth0/auth0-react";
import { Button, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select, Tooltip } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { ArrowLeft, Calendar, Search, X } from "react-feather";
import { toast } from "react-smart-toaster";
import styles from "./adddeviceform.module.css";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import DateRangePicker from "rsuite/DateRangePicker";
import moment from "moment";
import { AddLogCallAPI } from "../../../../../../components/AddLogs";

const schema = yup.object().shape({
    property_id: yup.string().required("This field is Required"),
    apt_id: yup.string().required("This field is Required")
});

const AddDeviceForm = ({ setShowAddFormNew, setSnackbarMsg, setSnackbarOpen, onSubmitLocal, setLoading, tenantData }) => {
    const { getAccessTokenSilently } = useAuth0();
    const [allTuyaDeviceList, setAllTuyaDeviceList] = useState([]);
    const [tuyaDeviceList, setTuyaDeviceList] = useState([]);
    const [deviceList, setDeviceList] = useState([]);
    const [deviceIds, setDeviceIds] = useState([]);
    const [propertyList, setPropertyList] = useState([]);
    const [apartmentList, setApartmentList] = useState([]);
    const [defaultDateFilter, setDefaultDateFilter] = useState(null);
    const [filterObj, setFilterObj] = useState({ type: '', status: '' });
    const [searchKey, setSearchKey] = useState("");
    const [selectedDeviceIds, setSelectedDeviceIds] = useState([]);
    const [selectedDevices, setSelectedDevices] = useState([]);
    const [cuurentStep, setCuurentStep] = useState(1);

    const { handleSubmit, control, setValue, errors } = useForm({
        resolver: yupResolver(schema),
        mode: "onChange",
        defaultValues: {
            property_id: "",
            apt_id: ""
        }
    });

    useEffect(() => {
        if (tenantData) {
            setPropertyList([{ value: tenantData?.property?.id, label: tenantData?.property?.name }]);
            setApartmentList([{ value: tenantData?.apartment?.id, label: tenantData?.apartment?.apt_no }]);

            setValue('property_id', tenantData?.property?.id);
            setValue('apt_id', tenantData?.apartment?.id);
        }
    }, [tenantData, setValue, cuurentStep]);

    useEffect(() => {
        const fetchDeviceList = async () => {
            setLoading(true);
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
            await axios.get(process.env.REACT_APP_DEVICE_API_URL + "v1/all-tuya-devices", {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then((response) => {
                setLoading(false);
                setAllTuyaDeviceList(response.data.data);
            }).catch((error) => {
                setLoading(false);
                if (typeof error.response !== "undefined")
                    toast.error(error.response.data.message);
            });
        };
        fetchDeviceList();
    }, [getAccessTokenSilently]);

    useEffect(() => {
        const fetchDeviceIdList = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
            await axios.get(process.env.REACT_APP_DEVICE_API_URL + "v1/all-device-ids", {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then((response) => {
                setDeviceIds(response.data.data);
            }).catch((error) => {
                if (typeof error.response !== "undefined")
                    toast.error(error.response.data.message);
            });
        };
        fetchDeviceIdList();
    }, [getAccessTokenSilently]);

    useEffect(() => {
        if (allTuyaDeviceList.length) {
            let tempDeviceList = allTuyaDeviceList.filter(i => deviceIds.indexOf(i.id) === -1);
            tempDeviceList.sort((a, b) => a.active_time < b.active_time ? 1 : -1)

            setTuyaDeviceList(tempDeviceList);
        }
    }, [deviceIds, allTuyaDeviceList]);

    useEffect(() => {
        if (tuyaDeviceList.length) {
            let tempDeviceList = tuyaDeviceList;

            if (searchKey !== '') {
                let inputVal = searchKey;
                inputVal = inputVal.toLowerCase();

                tempDeviceList = tempDeviceList.filter((item) => {
                    return (item?.id?.toLowerCase().includes(inputVal) || item?.name?.toLowerCase().includes(inputVal) || item?.product_name?.toLowerCase().includes(inputVal));
                });
            }

            if (defaultDateFilter) {
                tempDeviceList = tempDeviceList.filter(i => {
                    if (moment(moment.unix(i?.active_time).format("YYYY-MM-DD")).isBetween(moment(defaultDateFilter[0]).format("YYYY-MM-DD"), moment(defaultDateFilter[1]).format("YYYY-MM-DD"), undefined, [])) {
                        return true;
                    }
                    return false;
                })
            }

            if (filterObj?.type !== '' && filterObj?.type !== 'all') {
                tempDeviceList = tempDeviceList.filter((i) => i.product_name === filterObj.type);
            }

            if (filterObj?.status !== '' && filterObj?.status !== 'all') {
                if (filterObj?.status === 'online') {
                    tempDeviceList = tempDeviceList.filter((i) => i.online);
                }
                if (filterObj?.status === 'offline') {
                    tempDeviceList = tempDeviceList.filter((i) => !i.online);
                }
            }

            setDeviceList(tempDeviceList);
        }
    }, [tuyaDeviceList, defaultDateFilter, searchKey, filterObj]);

    const onSubmit = async (data) => {
        if (selectedDeviceIds.length === 0) {
            toast.error('Please select device.');
            return false;
        }

        setLoading(true);
        data = { ...data, devices: selectedDevices };

        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
        axios.post(process.env.REACT_APP_DEVICE_API_URL + "v1/add-multiple-devices", data, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then((response) => {
            setLoading(false);
            setShowAddFormNew(false);

            setSnackbarMsg(response.data.message);
            setSnackbarOpen(true);

            let rData = response.data.data;
            onSubmitLocal(rData);

            rData?.map(item => {
                let logData = {
                    'title': 'New smart device is created',
                    'description': [
                        'Device name: ' + item.name,
                        'Device id: ' + item.deviceID,
                        'Product type: ' + item.product_type,
                        'Location: ' + item.location
                    ]
                }
                AddLogCallAPI(logData, token);

                return false;
            });

        }).catch((error) => {
            setLoading(false);
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
        });
    }

    const getLocationVal = (id) => {
        if (selectedDeviceIds.indexOf(id) > -1) {
            let deviceTemp = selectedDevices?.filter(i => i?.id === id);
            if (deviceTemp?.length > 0) {
                return deviceTemp[0]?.location;
            }
        }
        return '';
    }

    return (<>
        <DialogTitle id="alert-dialog-title">
            <button className={`${styles.BackAddBU}`} onClick={(e) => setShowAddFormNew(false)}><ArrowLeft /></button>
            Add Device
            <button onClick={(e) => setShowAddFormNew(false)}><X /></button>
        </DialogTitle>
        <DialogContent className={`${styles.RequestBodyPop}`}>
            {cuurentStep === 1 && <div className={`${styles.ModalFormGroup}`}>
                <div className={`${styles.AddDeviceSec}`}>
                    <div className={`${styles.SearchConSec}`}>
                        <Search />
                        <input type="text" placeholder="Search" onChange={(e) => setSearchKey(e.target.value)} />
                    </div>
                    <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width150} CusSelectFilter Filter`}>
                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Device Type</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                label="Device Type"
                                value={filterObj?.type}
                                onChange={(e) => {
                                    setFilterObj((prev) => {
                                        return { ...prev, type: e.target.value };
                                    });
                                }}
                            >
                                <MenuItem value={'all'}>All</MenuItem>
                                <MenuItem value={'Smart Dimmer Switch'}>Smart Dimmer Switch</MenuItem>
                                <MenuItem value={'Thermostat'}>Thermostat</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                    <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width150} CusSelectFilter Filter`}>
                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Status</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                label="Status"
                                value={filterObj?.status}
                                onChange={(e) => {
                                    setFilterObj((prev) => {
                                        return { ...prev, status: e.target.value };
                                    });
                                }}
                            >
                                <MenuItem value={'all'}>All</MenuItem>
                                <MenuItem value={'online'}>Online</MenuItem>
                                <MenuItem value={'offline'}>Offline</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                    <div className={`${styles.AddDeviceDatePick} DashFilterSec AddDevice`}>
                        <DateRangePicker
                            format={"M/d/yy"}
                            placeholder={"Filter by date"}
                            placement={"bottomEnd"}
                            caretAs={Calendar}
                            showOneCalendar
                            onChange={(e) => setDefaultDateFilter(e)}
                        />
                    </div>
                </div>
                <p className={`${styles.DeviceSelectedMSG}`}>{(selectedDeviceIds?.length > 0 ? (selectedDeviceIds?.length > 1 ? selectedDeviceIds?.length + ' devices selected' : selectedDeviceIds?.length + ' device selected') : 'No device selected')}</p>
                <div className={`${styles.AddDeviceRow}`}>
                    {deviceList?.map((item, index) => {
                        return (<div className={`${styles.AddDeviceList}`} key={index}>
                            <div className={selectedDeviceIds.indexOf(item?.id) > -1 ? `${styles.AddDeviceListUnder} ${styles.Active}` : `${styles.AddDeviceListUnder}`}>
                                <div className={`${styles.AddDeviceListHeadSec}`}>
                                    <div className={`${styles.AddDeviceListIconSec}`}>
                                        {(item?.product_name === 'Smart Dimmer Switch' ? <img src="/static/img/bulb.svg" width="24px" height="24px" alt="" /> : (item?.product_name === 'Thermostat' ? <img src="/static/img/temperature.svg" width="24px" height="24px" alt="" /> : <img src="/static/img/smart-device-default.svg" width="24px" height="24px" alt="" />))}
                                    </div>
                                    <div className={`${styles.AddDeviceListTitleSec}`}>
                                        <p className={`${styles.AddDeviceListTitle}`}>
                                            <Tooltip title={item.name} placement="bottom-start">{item?.name}</Tooltip>
                                            {item?.online && <span className={`${styles.OpenBadge}`}>Online</span>}
                                            {!item?.online && <span className={`${styles.OfflineBadge}`}>Offline</span>}
                                        </p>
                                        <p className={`${styles.AddDeviceListTitle}`}><Tooltip title={item?.product_name} placement="bottom-start">{item?.product_name}</Tooltip></p>
                                    </div>
                                </div>
                                <div className={`${styles.ProspectCardFootSec}`}>
                                    <p className={`${styles.ProsCardDate}`}>{moment.unix(item?.active_time).fromNow()}</p>
                                    <div className={selectedDeviceIds.indexOf(item?.id) > -1 ? `${styles.MainReqConDropBU} FormGroup SelectRoom Active` : `${styles.MainReqConDropBU} FormGroup SelectRoom`}>
                                        <FormControl fullWidth>
                                            <InputLabel id="demo-simple-select-label">Select Room</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                label="Select Room"
                                                value={getLocationVal(item?.id)}
                                                onChange={(e) => {
                                                    if (selectedDeviceIds.indexOf(item?.id) === -1) {
                                                        setSelectedDeviceIds(prev => {
                                                            return prev.concat([item?.id]);
                                                        });
                                                        setSelectedDevices(prev => {
                                                            return prev.concat([{ id: item?.id, name: item?.name, online: item?.online, location: e.target.value, product_name: item?.product_name }]);
                                                        });
                                                    } else {
                                                        setSelectedDevices(prev => {
                                                            return prev.map(i => {
                                                                if (i?.id === item?.id)
                                                                    return { ...i, location: e.target.value };
                                                                return i;
                                                            });
                                                        });
                                                    }
                                                }}
                                            >
                                                <MenuItem value={'Bedroom'}>Bedroom</MenuItem>
                                                <MenuItem value={'Bedroom Closet'}>Bedroom Closet</MenuItem>
                                                <MenuItem value={'Bathroom'}>Bathroom</MenuItem>
                                                <MenuItem value={'Living Room'}>Living Room</MenuItem>
                                                <MenuItem value={'Living Room Closet'}>Living Room Closet</MenuItem>
                                            </Select>
                                        </FormControl>
                                        <button className={`${styles.ResetRoomSelect}`} type="button" onClick={(e) => {
                                            setSelectedDeviceIds(prev => {
                                                return prev.filter(i => i !== item?.id);
                                            });
                                            setSelectedDevices(prev => {
                                                return prev.filter(i => i?.id !== item?.id);
                                            });
                                        }}><X /></button>
                                    </div>
                                </div>
                            </div>
                        </div>);
                    })}
                </div>
                <div className={`${styles.ButtonAction}`}>
                    <Button className="CancelPopupBU" onClick={(e) => setShowAddFormNew(false)}>Cancel</Button>
                    <Button className="SubmitPopupBU" onClick={(e) => {
                        if (selectedDeviceIds.length === 0) {
                            toast.error('Please select device.');
                            return false;
                        }
                        setCuurentStep(2);
                    }}>Next</Button>
                </div>
            </div>}

            {cuurentStep === 2 && <div className={`${styles.ModalFormGroupTwo}`}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className={`${styles.AddDeviceFormTwo}`}>
                        <div className={`${styles.AddDeviceFormRow}`}>
                            <p className={`${styles.AddDeviceFormTitle}`}>Location</p>
                            <div className={`${styles.OneThirdSec} FormGroup AddDevice`}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Property*</InputLabel>
                                    <Controller
                                        name="property_id"
                                        control={control}
                                        render={(field) => (
                                            <Select
                                                {...field}
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                label="Property*"
                                            >
                                                {propertyList.map(i => {
                                                    return <MenuItem key={i?.value} value={i?.value}>{i?.label}</MenuItem>
                                                })}
                                            </Select>
                                        )}
                                    />
                                </FormControl>
                                {errors?.property_id && (<p className={`${styles.ErrorM}`}>{errors?.property_id?.message}</p>)}
                            </div>
                            <div className={`${styles.OneThirdSec} FormGroup AddDevice`}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Apartment*</InputLabel>
                                    <Controller
                                        name="apt_id"
                                        control={control}
                                        render={(field) => (
                                            <Select
                                                {...field}
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                label="Apartment*"
                                            >
                                                {apartmentList.map(i => {
                                                    return <MenuItem key={i?.value} value={i?.value}>{i?.label}</MenuItem>
                                                })}
                                            </Select>
                                        )}
                                    />
                                </FormControl>
                                {errors?.apt_id && (<p className={`${styles.ErrorM}`}>{errors?.apt_id?.message}</p>)}
                            </div>
                        </div>
                    </div>
                    <p className={`${styles.DeviceSelectedMSG}`}>{(selectedDeviceIds?.length > 0 ? (selectedDeviceIds?.length > 1 ? selectedDeviceIds?.length + ' devices selected' : selectedDeviceIds?.length + ' device selected') : 'No device selected')}</p>
                    <ul className={`${styles.SelectedDeviceList}`}>
                        {selectedDevices?.map((item, index) => {
                            return (<li key={index}>
                                {(item?.product_name === 'Smart Dimmer Switch' ? <img src="/static/img/bulb.svg" width="20px" height="20px" alt="" /> : (item?.product_name === 'Thermostat' ? <img src="/static/img/temperature.svg" width="20px" height="20px" alt="" /> : <img src="/static/img/smart-device-default.svg" width="20px" height="20px" alt="" />))}
                                <p>{item?.name} /</p>
                                <div className={`${styles.SelectRoomStepTwo} FormGroup SelectRoom Two`}>
                                    <FormControl fullWidth>
                                        <InputLabel id="demo-simple-select-label">Select Room</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            label="Select Room"
                                            value={getLocationVal(item?.id)}
                                            onChange={(e) => {
                                                if (selectedDeviceIds.indexOf(item?.id) === -1) {
                                                    setSelectedDeviceIds(prev => {
                                                        return prev.concat([item?.id]);
                                                    });
                                                    setSelectedDevices(prev => {
                                                        return prev.concat([{ id: item?.id, name: item?.name, online: item?.online, location: e.target.value, product_name: item?.product_name }]);
                                                    });
                                                } else {
                                                    setSelectedDevices(prev => {
                                                        return prev.map(i => {
                                                            if (i?.id === item?.id)
                                                                return { ...i, location: e.target.value };
                                                            return i;
                                                        });
                                                    });
                                                }
                                            }}
                                        >
                                            <MenuItem value={'Bedroom'}>Bedroom</MenuItem>
                                            <MenuItem value={'Bedroom Closet'}>Bedroom Closet</MenuItem>
                                            <MenuItem value={'Bathroom'}>Bathroom</MenuItem>
                                            <MenuItem value={'Living Room'}>Living Room</MenuItem>
                                            <MenuItem value={'Living Room Closet'}>Living Room Closet</MenuItem>
                                        </Select>
                                    </FormControl>
                                </div>
                            </li>)
                        })}
                    </ul>
                    <div className={`${styles.ButtonAction}`}>
                        <Button onClick={(e) => setCuurentStep(1)} className="CancelPopupBU">Back</Button>
                        <Button className="SubmitPopupBU" type="submit">Add</Button>
                    </div>
                </form>
            </div>}
        </DialogContent>
    </>);
}

export default AddDeviceForm;